import { render, staticRenderFns } from "./Landowner.vue?vue&type=template&id=4e0b55f2&scoped=true&"
import script from "./Landowner.vue?vue&type=script&lang=js&"
export * from "./Landowner.vue?vue&type=script&lang=js&"
import style0 from "./Landowner.vue?vue&type=style&index=0&id=4e0b55f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0b55f2",
  null
  
)

export default component.exports